import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';


/**
 * Menu item in the header
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: '[app-nav-item]',
    templateUrl: './nav-item.component.html',
    styleUrls: ['./nav-item.component.scss'],
    imports: [RouterLinkActive, RouterLink, NgClass],
})
export class NavItemComponent {
    /**
     * Link
     */
    @Input()
    public link: string[] | string;

    /**
     * Icon
     */
    @Input()
    public icon: string;

    /**
     * Additional css class for customization
     */
    @Input()
    public customClass: string[] = [];

    /**
     * Attribute title text
     */
    @Input()
    public titleText: string;
}
